// Which items a "second opinion — all items" batch should ask ChatGPT about.
//
// An item qualifies only when BOTH hold:
//   1. We can address it — it carries a `quote_item_id`. The per-item endpoint is
//      keyed by that id; an item whose identity did not come through with the quote
//      cannot be researched (the panel refuses it too), so it is skipped, not guessed.
//   2. It has no opinion worth keeping — a completed 'ok'/'no_data' result would be
//      re-paid for (~$0.25 each), and a 'pending' one is already running (the worker's
//      idempotency no-ops a re-fire anyway). So skip ok/no_data/pending and fire
//      everything else ('none' | 'error' | undefined-when-unread).
//
// `statusByItemId` maps quote_item_id → the latest second-opinion status string,
// or undefined when the status was not read.
const DONE_OR_RUNNING = new Set(['ok', 'no_data', 'pending']);

export function secondOpinionTargets(items, statusByItemId) {
    return (items || []).filter(it => {
        if (!it || !it.quote_item_id) return false;
        const status = statusByItemId ? statusByItemId[it.quote_item_id] : undefined;
        return !DONE_OR_RUNNING.has(status);
    });
}
